export default __webpack_public_path__ + "assets/images/4297f5046becf610ad8de2b9fbcd3150.svg";